import { render, staticRenderFns } from "./DataPrivacy.vue?vue&type=template&id=2246c259&scoped=true"
import script from "./DataPrivacy.vue?vue&type=script&lang=js"
export * from "./DataPrivacy.vue?vue&type=script&lang=js"
import style0 from "./DataPrivacy.vue?vue&type=style&index=0&id=2246c259&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2246c259",
  null
  
)

export default component.exports